// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"b4b96ec1","229":"5ba62150","453":"68693753","697":"6ecfcbbf","753":"907be370","954":"9a92bed9"}[chunkId] + ".chunk.js";
};